

















































































































































































































































































































































































































































































































import { format } from 'date-fns'
import { mapGetters } from 'vuex'
import { AxiosResponse } from 'axios'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { coreKaizen } from '@/common/coreKaizen'
import { tipoEntidadModel } from '@/models/certificaciones/tipoEntidadModel'
import { organizacionResultModel, entidadModel } from '@/models/certificaciones/organizacionResultModel'
import { header } from '@/models/vuetify/tableModel'
import { resultByNameEmpresaModel } from '@/models/certificaciones/resultByNameEmpresaModel'
import { resultByNameSociedadModel } from '@/models/certificaciones/resultByNameSociedadModel'
import { filtrosModel } from '@/models/certificaciones/filtrosModel'
import { certificacionModel } from '@/models/certificaciones/certificacionModel';
import { ticketLogModel } from '@/models/kaizen/ticketLogModel';
import router from '@/router';

const namespace: string = 'oidcStore/';

@Component({
    computed: {
        ...mapGetters(namespace, [
            'oidcIsAuthenticated',
            'oidcUser'
        ])
    }
})
export default class certificacionRegistro extends coreKaizen {
    @Prop(String) ticketID!: string

    filtros: filtrosModel[] = [
        { id: "exp", name: "Filtro por expediente" },
        { id: "rfl", name: "Filtro por registro, folio y libro" },
        { id: "name", name: "Filtro por nombre" }
    ]
    ticketLog: ticketLogModel[] = []
    dialogSaveGestion: boolean = false
    filtroSeleccionado: string = ''
    valid: boolean = false
    nombreBusqueda: string = ''
    filtroRS: boolean = true
    labelRS: string = 'Raz\u{f3}n social'
    filtroNC: boolean = true
    labelNC: string = 'Nombre comercial'
    tiposEntidad: tipoEntidadModel[] = []
    tiposCertificaciones: tipoEntidadModel[] = []
    tipoEntidad: number = 0
    tipoCertificacion: number = 0
    isLoading: boolean = false
    hintTipoEntidad: string = 'Este es un pre-requisito para activar la funci\u{f3}n de b\u{fa}squeda'
    hintTipoCertificacion: string = 'Existen 14 tipos de certificaci\u{f3}n modelados en el sistema actualmente'
    direccionSolicitanteLabel: string = 'Direcci\u{f3}n del solicitante'
    searchByNameLabel: string = 'Criterio de b\u{fa}squeda'
    emailSolicitanteLabel: string = 'Correo electr\u{f3}nico'
    noDataText: string = 'No se encontraron registros que coincidieran con los t\u{e9}rminos de b\u{fa}squeda'
    telefonoSolicitanteLabel: string = 'Tel\u{e9}fono'
    showResults: boolean = false
    showSearchByNameResults: boolean = false
    RFLRules: any = [(v: string) => !!v || 'Campo requerido']
    organizacionResult: organizacionResultModel = { dataFound: false, items: [] }
    validSearchByExp: boolean = false
    validSearchByRFL: boolean = false
    validSearchByName: boolean = false
    validSolicitante: boolean = false
    isSearching: boolean = false
    rowsPerPageItems: number[] = [4, 8, 12]
    snackBarText: string = ''
    snackbar: boolean = false
    emptyEntidadTipo: entidadModel = { id: "", registro: "", folio: 0, libro: 0, name: "", props: [] }
    selectedEntidad: entidadModel = this.emptyEntidadTipo
    isPosting: boolean = false
    headersEmpresas: header[] = [
        { text: 'Acciones', align: 'center', sortable: false, value: '' },
        { text: 'Registro', align: 'center', sortable: true, value: 'registro' },
        { text: 'Folio', align: 'center', sortable: true, value: 'folio' },
        { text: 'Libro', align: 'center', sortable: true, value: 'libro' },
        { text: 'Correlativo', align: 'center', sortable: true, value: 'correlativo' },
        { text: 'A\u{f1}o', align: 'center', sortable: true, value: 'ejercicio' },
        { text: 'Nombre comercial', align: 'left', sortable: true, value: 'nombreComercial' },
        { text: 'Direcci\u{f3}n', align: 'left', sortable: true, value: 'direccion' }
    ]
    headersSociedades: header[] = [
        { text: 'Acciones', align: 'center', sortable: false, value: '' },
        { text: 'Registro', align: 'center', sortable: true, value: 'registro' },
        { text: 'Folio', align: 'center', sortable: true, value: 'folio' },
        { text: 'Libro', align: 'center', sortable: true, value: 'libro' },
        { text: 'Extranjera', align: 'center', sortable: true, value: 'libro' },
        { text: 'Correlativo', align: 'center', sortable: true, value: 'correlativo' },
        { text: 'A\u{f1}o', align: 'center', sortable: true, value: 'ejercicio' },
        { text: 'Raz\u{f3}n social', align: 'left', sortable: true, value: 'razonSocial' },
        { text: 'Nombre comercial', align: 'left', sortable: true, value: 'nombreComercial' }
    ]
    empresasByName: resultByNameEmpresaModel[] = []
    sociedadesByName: resultByNameSociedadModel[] = []
    pagination = {
        rowsPerPage: 4
    }
    emptyEntidad: certificacionModel = {
        boleta: 0,
        certificacion: { correlativo: 0, ejercicio: 0 },
        registro: '',
        folio: 0,
        libro: 0,
        descripcion: '',
        expediente: { correlativo: 0, ejercicio: 0 },
        extranjera: false,
        fechaPublicacion: new Date(),
        fechaTra: new Date(),
        fechaTra2: new Date(),
        organizacion: '',
        solicitante: { nombre: '', telefono: '', direccion: '', dpi: '', e_mail: '' },
        ticket: 0,
        tipoCertificacion: 0,
        tipoEntidad: 0,
        titular: { numero: '', tipo: '' },
        referenceData: {
            dataFound: false, items: [
                {
                    titular: { numero: '', tipo: '' },
                    expediente: { correlativo: 0, ejercicio: 0 },
                    extranjera: false,
                    registro: '',
                    folio: 0,
                    libro: 0,
                    id: '',
                    name: '',
                    props: []
                }
            ]
        }
    }
    entidad: certificacionModel = this.emptyEntidad

    @Watch('tipoEntidad')
    resetSearchFilters() {
        this.cleanRFLFilter()
        this.cleanExpFilter()
        this.cleanNameFilter()
        this.showResults = false
        this.showSearchByNameResults = false
        this.filtroSeleccionado = ''
    }

    resetForms() {
        this.entidad = this.emptyEntidad
        this.dialogSaveGestion = false
    }

    mounted() {
        this.getTicketData()
        this.getTicketLog()
    }

    get filtrosElegibles(): filtrosModel[] {
        return (this.isEmpresa || this.isSociedad) ? this.filtros : this.filtros.filter(x => x.id !== "name")
    }

    get isEmpresa(): boolean {
        return this.tipoEntidad === 1
    }

    get isSociedad(): boolean {
        return this.tipoEntidad === 2
    }

    get namedResultsHeaders(): header[] {
        return this.isEmpresa ? this.headersEmpresas : this.headersSociedades
    }

    get resultMoreThanOneEntity(): boolean {
        if (this.organizacionResult) {
            if (this.organizacionResult.items) {
                return this.organizacionResult.items.length > 1
            }
        }
        return false;
    }

    get resultSelected(): boolean {
        if (this.selectedEntidad) {
            if (this.selectedEntidad.registro) {
                return this.selectedEntidad.registro.length > 0;
            }
        }
        return false;
    }

    get resultHasExpediente(): boolean {
        if (this.resultSelected) {
            if (this.selectedEntidad.expediente) {
                return true
            }
        }
        return false;
    }

    get resultHasTitular(): boolean {
        if (this.resultSelected) {
            if (this.selectedEntidad.titular && this.selectedEntidad.titular.numero) {
                return true
            }
        }
        return false;
    }

    get resultHasLibro(): boolean {
        if (this.resultSelected) {
            if (this.selectedEntidad.libro) {
                return true
            }
        }
        return false;
    }

    dateFormat(value: Date): string {
        return format(value, 'DD-MM-YYYY hh:mm:ss aa')
    }

    getTicketLog() {
        this.isLoading = true
        this.GilgameshApi.get(`certificaciones/${this.ticketID}/history`)
            .then(r => r as AxiosResponse<ticketLogModel[]>)
            .then(d => {
                this.ticketLog = d.data
                if (this.ticketLog && this.ticketLog.length > 0) {
                    this.ticketLog.forEach((x, i, m) => {
                        if (i === 0) {
                            x.icon = 'star'
                            x.color = 'red lighten-2'
                        }
                        else if (i < m.length - 1) {
                            x.icon = 'assignment'
                            x.color = 'green lighten-1'
                        }
                        else {
                            x.icon = 'assignment'
                            x.color = 'indigo'
                        }
                    })
                }
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }

    getTicketData() {
        if (this.ticketID) {
            this.isLoading = true
            this.GilgameshApi.get(`certificaciones/${this.ticketID}`)
                .then(r => r as AxiosResponse<certificacionModel>)
                .then(d => {
                    this.entidad = d.data
                    if (this.entidad && this.entidad.tipoEntidad) {
                        this.tipoEntidad = this.entidad.tipoEntidad
                    }
                    if (this.entidad && this.entidad.tipoCertificacion) {
                        this.tipoCertificacion = this.entidad.tipoCertificacion
                    }
                    this.filtroSeleccionado = "rfl"
                    return this.searchByRFL()
                }).then(() => {
                    return this.getTiposCertificacion()
                }).then(() => {
                    return this.getTiposEntidad()
                })
                .catch(x => console.log('reason: ' + x))
                .finally(() => this.isLoading = false)
        }
    }

    tituloEntidad(name: string, id: string) {
        return name + ' - ' + id
    }

    getTiposCertificacion() {
        this.isLoading = true
        this.GilgameshApi.get('certificaciones/tipoCertificacion')
            .then(r => r as AxiosResponse<tipoEntidadModel[]>)
            .then(d => {
                this.tiposCertificaciones = d.data
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }

    getTiposEntidad() {
        this.isLoading = true
        this.GilgameshApi.get('certificaciones/tipoEntidad')
            .then(r => r as AxiosResponse<tipoEntidadModel[]>)
            .then(d => {
                this.tiposEntidad = d.data
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }

    noResultsBehavior() {
        this.snackbar = true
        this.snackBarText = 'No se encontraron datos que concuerden con los par\u{e1}metros de b\u{fa}squeda'
        this.showResults = false
        this.showSearchByNameResults = false
        this.dialogSaveGestion = true
    }

    cleanRFLFilter() {
        this.entidad.registro = ''
        this.entidad.folio = 0
        this.entidad.libro = 0
    }

    cleanExpFilter() {
        this.entidad.expediente.correlativo = 0
        this.entidad.expediente.ejercicio = 0
    }

    cleanNameFilter() {
        this.nombreBusqueda = ''
        this.filtroNC = true
        this.filtroRS = true
    }

    selectItemByName(item: resultByNameEmpresaModel) {
        this.selectedEntidad.registro = item.registro
        this.selectedEntidad.folio = item.folio
        this.selectedEntidad.libro = item.libro
        this.selectedEntidad.expediente = { correlativo: item.correlativo, ejercicio: item.ejercicio }
        this.selectedEntidad.titular = { numero: "", tipo: "" }
        this.dialogSaveGestion = true
    }

    async searchByName() {
        this.cleanRFLFilter()
        this.cleanExpFilter()
        if (!this.isSearching) {
            this.isSearching = true
            let uriBackend: string = ''
            if (this.isEmpresa) {
                uriBackend = `certificaciones/searchByName/${this.tipoEntidad}/${this.nombreBusqueda}`
                await this.searchDataByName<resultByNameEmpresaModel>(uriBackend)
                    .then(d => {
                        this.empresasByName = d
                        this.showSearchByNameResults = true
                    })
                    .catch(x => console.log('reason: ' + x))
                    .finally(() => {
                        this.isSearching = false
                        this.$nextTick(() => {
                            const myDiv = <HTMLDivElement>this.$refs.searchNamesStart;
                            if (myDiv !== undefined) {
                                window.scrollTo(0, myDiv.offsetTop)
                            }
                        })
                    })
            } else if (this.isSociedad) {
                uriBackend = `certificaciones/searchByName/${this.tipoEntidad}/${this.nombreBusqueda}/${this.filtroRS}/${this.filtroNC}`
                await this.searchDataByName<resultByNameSociedadModel>(uriBackend)
                    .then(d => {
                        this.sociedadesByName = d
                        this.showSearchByNameResults = true
                    })
                    .catch(x => console.log('reason: ' + x))
                    .finally(() => {
                        this.isSearching = false
                        this.$nextTick(() => {
                            const myDiv = <HTMLDivElement>this.$refs.searchNamesStart;
                            if (myDiv !== undefined) {
                                window.scrollTo(0, myDiv.offsetTop)
                            }
                        })
                    })
            }
            else {
                this.isSearching = false
                this.snackbar = true
                this.snackBarText = 'Esta opci\u{f3}n solo est\u{e1} habilitada para Empresas y Sociedades'
            }
        }
    }

    searchByEXP() {
        this.cleanRFLFilter()
        this.cleanNameFilter()
        if (!this.isSearching) {
            this.isSearching = true
            const uriBackend: string = `certificaciones/organizacion/${this.tipoEntidad}/${this.entidad.expediente.correlativo}/${this.entidad.expediente.ejercicio}`
            this.searchProcess(uriBackend)
        }
    }

    searchByRFL() {
        this.nombreBusqueda = ''
        if (!this.isSearching) {
            this.isSearching = true
            let uriBackend: string = ''
            if (this.tipoEntidad === 2 || this.tipoEntidad === 8 || this.tipoEntidad === 10) {
                this.entidad.extranjera = this.tipoEntidad === 8
                uriBackend = `certificaciones/organizacion/${this.tipoEntidad}/${this.entidad.registro}/${this.entidad.folio}/${this.entidad.libro}/${this.entidad.extranjera}`
            }
            else {
                uriBackend = `certificaciones/organizacion/${this.tipoEntidad}/${this.entidad.registro}/${this.entidad.folio}/${this.entidad.libro}`
            }
            this.searchProcess(uriBackend);
        }
    }

    searchDataByName<T>(uriBackEnd: string): Promise<T[]> {
        return this.GilgameshApi.get(uriBackEnd)
            .then(r => r as AxiosResponse<T[]>)
            .then(d => d.data)
    }

    async searchProcess(uriBackend: string) {
        await this.GilgameshApi.get(uriBackend)
            .then(r => r as AxiosResponse<organizacionResultModel>)
            .then(d => {
                this.organizacionResult = d.data
                this.entidad.referenceData.dataFound = d.data.dataFound
                this.entidad.referenceData.items = d.data.items
                if (!this.organizacionResult.dataFound) {
                    this.noResultsBehavior();
                }
                else {
                    this.showResults = true
                    if (!this.resultMoreThanOneEntity) {
                        this.selectedEntidad = this.organizacionResult.items[0]
                    }
                    else {
                        this.selectedEntidad = this.emptyEntidadTipo
                    }
                }
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => {
                this.isSearching = false
                this.$nextTick(() => {
                    const myDiv = <HTMLDivElement>this.$refs.searchStart;
                    if (myDiv !== undefined) {
                        window.scrollTo(0, myDiv.offsetTop)
                    }
                })
            })
    }

    save() {
        if (!this.isPosting) {
            this.isPosting = true
            if (this.resultSelected) {
                if (this.selectedEntidad.registro) {
                    this.entidad.registro = this.selectedEntidad.registro
                }
                if (this.selectedEntidad.folio) {
                    this.entidad.folio = this.selectedEntidad.folio
                }
                if (this.selectedEntidad.libro) {
                    this.entidad.libro = this.selectedEntidad.libro
                }                    
                if (this.selectedEntidad.expediente) {
                    this.entidad.expediente = this.selectedEntidad.expediente
                }
                if (this.selectedEntidad.extranjera) {
                    this.entidad.extranjera = this.selectedEntidad.extranjera
                }
                if (this.selectedEntidad.titular) {
                    this.entidad.titular = this.selectedEntidad.titular
                }
            }
            this.GilgameshApi.put(`certificaciones/${this.ticketID}`, this.entidad)
                .then(r => {
                    if (r.status === 200) {
                        this.snackbar = true
                        this.snackBarText = "Se ha actualizado la gestión con código de ticket "
                    }
                }).catch((error) => {
                    // Error
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        // console.log(error.response.data);
                        // console.log(error.response.status);
                        // console.log(error.response.headers);
                        this.snackbar = true
                        this.snackBarText = error.response.data ? error.response.data : 'No se ha registrado el cambio en el sistema'
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log(error.request)
                        this.snackbar = true
                        this.snackBarText = 'No se ha recibido respuesta del servidor'
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message)
                    }
                    console.log(error.config)
                }).finally(() => {
                    this.isPosting = false
                    setTimeout(function () {
                        router.push({ name: 'kanban' })
                    }, 4000)
                })
        }
    }
}
